import React from "react";
import { Form, Card, Switch, InputNumber } from "antd";
import _ from "lodash";

const MinMaxWidthComponent = ({ block, setBlock, disableWrite }: any) => {
    return (
        <Card
            title={<h4>Width</h4>}
            bodyStyle={{
                padding: block?.enabled ? "12px" : "0px",
            }}
            size="small"
            extra={
                <Switch
                    disabled={disableWrite}
                    size="small"
                    style={{ marginLeft: "12px" }}
                    checked={block?.enabled}
                    onChange={(val) => {
                        let tmpBlock = _.cloneDeep(block);
                        if (!tmpBlock) {
                            tmpBlock = {};
                        }
                        tmpBlock.enabled = val;
                        setBlock(tmpBlock);
                    }}
                />
            }
        >
            {block?.enabled && (
                <>
                    {/*Input Number field for min width with default 64px */}
                    <Form.Item label="Min">
                        <InputNumber
                            type="number"
                            disabled={disableWrite}
                            size="small"
                            width={100}
                            value={block?.minWidth ?? 64}
                            onChange={(e) => {
                                let tmpBlock = _.cloneDeep(block);
                                if (!tmpBlock) {
                                    tmpBlock = {};
                                }
                                tmpBlock.minWidth = e;
                                setBlock(tmpBlock);
                            }}
                            min={20}
                            max={block?.maxWidth ?? 1000}
                            step={1}
                        />
                    </Form.Item>
                    {/*Input Number field for max width with default 280 */}
                    <Form.Item label="Max">
                        <InputNumber
                            type="number"
                            disabled={disableWrite}
                            size="small"
                            width={100}
                            value={block?.maxWidth ?? 280}
                            onChange={(e) => {
                                let tmpBlock = _.cloneDeep(block);
                                if (!tmpBlock) {
                                    tmpBlock = {};
                                }
                                tmpBlock.maxWidth = e;
                                setBlock(tmpBlock);
                            }}
                            min={block?.minWidth ?? 20}
                            step={1}
                            max={1000}
                        />
                    </Form.Item>
                </>
            )}
        </Card>
    );
};

export default MinMaxWidthComponent;
